import { render, staticRenderFns } from "./JSelectAllUser.vue?vue&type=template&id=2531aa22&scoped=true"
import script from "./JSelectAllUser.vue?vue&type=script&lang=js"
export * from "./JSelectAllUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531aa22",
  null
  
)

export default component.exports